import React from 'react';
import './PoliticaPrivacidade.css';

export default function PoliticaPrivacidade() {
    return (
        <div className="privacy-page">
            <div className="privacy-container">

                <header className="privacy-header">
                    <div className="privacy-icon">🎺</div>

                    <h1>Política de Privacidade</h1>

                    <p>
                        Trombetas Louvor
                    </p>

                    <span>
                        Última atualização: 11 de setembro de 2026
                    </span>
                </header>

                <section>
                    <h2>1. Introdução</h2>

                    <p>
                        O aplicativo <strong>Trombetas Louvor</strong> foi desenvolvido
                        para oferecer uma experiência simples e agradável de ouvir
                        hinos e canções de adoração.
                    </p>

                    <p>
                        Esta Política de Privacidade explica como as informações são
                        tratadas durante o uso do aplicativo.
                    </p>
                </section>

                <section>
                    <h2>2. Informações coletadas</h2>

                    <p>
                        O Trombetas Louvor foi desenvolvido para funcionar sem exigir
                        que o usuário forneça informações pessoais para utilizar suas
                        principais funcionalidades.
                    </p>

                    <p>
                        O aplicativo não solicita diretamente informações como nome,
                        endereço, CPF ou número de telefone para permitir o acesso
                        às suas funcionalidades.
                    </p>
                </section>

                <section>
                    <h2>3. Dados de uso</h2>

                    <p>
                        Dependendo da configuração do aplicativo e dos serviços
                        utilizados para seu funcionamento, informações técnicas e
                        estatísticas de uso podem ser processadas por serviços de
                        terceiros utilizados pelo aplicativo.
                    </p>

                    <p>
                        Essas informações podem incluir dados técnicos do dispositivo,
                        sistema operacional, versão do aplicativo e informações
                        relacionadas ao funcionamento e desempenho do aplicativo.
                    </p>
                </section>

                <section>
                    <h2>4. Reprodução e músicas offline</h2>

                    <p>
                        O aplicativo permite que determinadas músicas sejam baixadas
                        para reprodução offline.
                    </p>

                    <p>
                        Os arquivos necessários para essa funcionalidade podem ser
                        armazenados localmente no dispositivo do usuário, permitindo
                        sua reprodução posteriormente sem conexão com a internet.
                    </p>
                </section>

                <section>
                    <h2>5. Permissões do aplicativo</h2>

                    <p>
                        O Trombetas Louvor poderá solicitar apenas as permissões
                        necessárias para oferecer suas funcionalidades.
                    </p>

                    <p>
                        As permissões utilizadas podem variar de acordo com a versão
                        do aplicativo e do sistema operacional do dispositivo.
                    </p>
                </section>

                <section>
                    <h2>6. Serviços de terceiros</h2>

                    <p>
                        O aplicativo poderá utilizar serviços de terceiros para
                        hospedagem, armazenamento, distribuição de conteúdo,
                        análise de funcionamento ou outros recursos necessários
                        para seu funcionamento.
                    </p>

                    <p>
                        Esses serviços possuem suas próprias políticas de privacidade
                        e práticas de tratamento de dados.
                    </p>
                </section>

                <section>
                    <h2>7. Segurança</h2>

                    <p>
                        Adotamos medidas razoáveis para proteger as informações
                        relacionadas ao funcionamento do aplicativo contra acesso,
                        alteração ou divulgação não autorizada.
                    </p>

                    <p>
                        Entretanto, nenhum método de armazenamento ou transmissão
                        de dados pela internet pode ser considerado completamente
                        seguro.
                    </p>
                </section>

                <section>
                    <h2>8. Privacidade de crianças</h2>

                    <p>
                        O Trombetas Louvor não tem como objetivo coletar
                        intencionalmente informações pessoais de crianças.
                    </p>

                    <p>
                        Caso seja identificado que informações pessoais de uma criança
                        foram fornecidas de forma inadequada, medidas razoáveis poderão
                        ser tomadas para tratar a situação.
                    </p>
                </section>

                <section>
                    <h2>9. Alterações nesta Política de Privacidade</h2>

                    <p>
                        Esta Política de Privacidade poderá ser atualizada
                        periodicamente para refletir alterações no aplicativo,
                        nos serviços utilizados ou na legislação aplicável.
                    </p>

                    <p>
                        Recomendamos que o usuário consulte esta página regularmente
                        para verificar eventuais alterações.
                    </p>
                </section>

                <section>
                    <h2>10. Contato</h2>

                    <p>
                        Caso tenha dúvidas, sugestões ou solicitações relacionadas
                        a esta Política de Privacidade ou ao aplicativo
                        <strong> Trombetas Louvor</strong>, entre em contato com o
                        desenvolvedor.
                    </p>

                    <p>
                        <strong>Desenvolvedor:</strong><br />
                        Luis Carlos Hilário Trentin
                    </p>
                </section>

                <footer className="privacy-footer">
                    <p>
                        © 2026 Trombetas Louvor. Todos os direitos reservados.
                    </p>
                </footer>

            </div>
        </div>
    );
}